import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SchabuOverlayComponent } from '@schabu/web.angular/components';
import { LanguageService } from '@schabu/web.angular/services';
import { OverlayComponentConfiguration } from '@schabu/web.core/builders';
import { Locale } from '@schabu/web.core/enumerations';
import { KeyValuePair } from '@schabu/web.core/models';
import { Dictionary } from '@schabu/web.core/types';
import { SchabuFooterComponent } from 'components/footer/footer.component';
import { SchabuHeaderComponent } from 'components/header/header.component';
import * as EnAU from "locales/messages.en-AU.json";

@Component({
	imports: [
		SchabuFooterComponent,
		SchabuHeaderComponent,
		SchabuOverlayComponent,
		RouterOutlet
	],
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent {
	public overlayConfig: OverlayComponentConfiguration;
	protected languageService: LanguageService = inject(LanguageService);

	constructor() {
		this.languageService.load(new Dictionary<Locale, Dictionary<string, string>>([
			new KeyValuePair<Locale, Dictionary<string, string>>(Locale.EN_AU, Dictionary.fromAny(EnAU.translations))
		]));
		
		this.languageService.locale = Locale.EN_AU;
		this.overlayConfig = (new OverlayComponentConfiguration.Builder()).build();
	}
}
